import type { Props1 } from "../Types";
import { sanitizeImageUrl } from "../imageUrl";

// Stopovers Carousels Card Layout
const CardLayout1 = ({image, title, introduction, href}: Props1) => {

    const introText = (text: string, maxLength: number) => {
        if (!text) return "";
        if (text.length <= maxLength) return text;
        const trimmed = text.substring(0, maxLength);
        const lastWord = trimmed.lastIndexOf(" ");
        return trimmed.substring(0, lastWord) + "...";  
    }

    const shortIntroText = introText(introduction || "", 74);

    return (
    <>
        <div className="card rounded-0 border-0 shadow-0 w-100 h-100">
            <a href={href} className="text-decoration-none text-dark">

                {/* Image */}
                <div className="ratio ratio-4x3">
                    <img 
                        className=" ls-is-cached lazyloaded object-fit-cover w-100 h-100" 
                        alt={title}
                        title={title}
                        src={sanitizeImageUrl(image, { width: 720 })}
                    />
                </div>

                {/* Body Content */}
                <div className="card-body p-3">
                    <div className="d-flex justify-content-between align-items-start gap-2 mb-4">
                        <p className="h6 mb-1 me-2 flex-grow-1 item-heading text-strong mb-0">{title}</p><br/>
                    </div>
                    <p className="fs-6">{shortIntroText}</p>
                </div>

            </a>
        </div>
    </>
    )
}

export default CardLayout1